<div class="popup-callout order-entry__panel-strategy__container gamma">
  <div #strategyLayoutPS class="strategy__viewer__diagram">
    <div
      *ngIf="gammaLadderModel.hasError==true"
      class="order-entry__panel-form-notifications__order-rejected__container gamma"
      [innerHTML]="gammaLadderModel.displayMessage"
      fxLayout="row"
    ></div>
    <!-- Header - follows same structure as row to simply change -->
    <div class="gamma-viewer__row gamma-viewer__header">
      <div class="gamma-viewer__row__divider">
        <div class="gamma-viewer__side">
          <label>{{gammaLadderModel.dirHeaderLabel}}</label>
        </div>
        <div class="gamma-viewer__amount">
          <label>{{gammaLadderModel.amountHeaderLabel}}</label>
        </div>
        <div class="gamma-viewer__rate">
          <label>{{gammaLadderModel.rateHeaderLabel}}</label>
        </div>
        <div class="gamma-viewer__delta">
          <label>{{gammaLadderModel.deltaHeaderLabel}}</label>
        </div>
        <div class="gamma-viewer__delete">
          <label></label>
        </div>
      </div>
    </div>
    <!-- All legs -->
    <div class="strategy__viewer__diagram__target" [style.height.px]="style.scroll.height">
      <!-- Above mid legs -->
      @for (rowData of gammaLadderModel.gammaLegsAbove; track rowData.legId) {
      <div class="gamma-viewer__row" [ngClass]="{ 'disabled' : !gammaLadderModel.edit }">
        <div class="gamma-viewer__row__divider">
          <div class="gamma-viewer__side">
            <label>{{rowData.directionLabel}}</label>
          </div>
          <div class="gamma-viewer__amount gamma-viewer__cell">
            <bfx-amount-spinner
              [externalState]="0"
              [showValidationBar]="false"
              [(ngModel)]="rowData.amount"
              [keyupAssignZero]="false"
              [disabled]="!gammaLadderModel.edit"
              [dead]="!gammaLadderModel.edit"
              size="sm"
            >
            </bfx-amount-spinner>
          </div>
          <div class="gamma-viewer__rate gamma-viewer__cell gamma-viewer__cell--last">
            <ic-price-spinner
              [inputId]="leg"
              [(ngModel)]="rowData.rate"
              [disabled]="!gammaLadderModel.edit"
              [externalState]="gammaLadderModel.externalState"
              [showValidationBar]="false"
              [productCode]="gammaLadderModel.currencyPair.product"
              [inverted]="gammaLadderModel.currencyPair.inverted"
              [dead]="!gammaLadderModel.edit"
              (ngModelChange)="handleSpinnerChange(rowData)"
              [max]="rowData.maxRate"
              [min]="rowData.minRate"
              size="sm"
            ></ic-price-spinner>
          </div>

          <div class="gamma-viewer__delta">
            <div>
              <label aria-multiline="false">{{rowData.deltaLabel}}</label>
            </div>
          </div>
          <div
            [ngClass]="{
                'gamma-viewer__delete__enabled': gammaLadderModel.edit,
                'gamma-viewer__delete__disabled': !gammaLadderModel.edit
              }"
            class="gamma-viewer__delete"
            [attr.disabled]="!gammaLadderModel.edit"
          >
            <bfx-icon-button
              class="remove-leg-button"
              tabindex="-1"
              size="sm"
              iconClass="icon_ion_remove_circle_filled"
              (action)="removeLeg(rowData)"
              title="Remove Leg"
              [disabled]="!gammaLadderModel.edit"
            ></bfx-icon-button>
          </div>
        </div>
      </div>
      }
      <!--/span-->

      <!-- Reference Mid row -->
      <div
        class="gamma-viewer__row"
        [ngClass]="{ 'disabled' : !gammaLadderModel.edit }"
        *ngFor="let rowData of gammaLadderModel.midRate"
        fxLayout="row"
      >
        <div class="gamma-viewer__row__divider">
          <!-- use same css classes as above (in different order) so that resizing duer to flex works -->
          <div class="gamma-viewer__amount">
            <label>Reference Mid:</label>
          </div>
          <div class="gamma-viewer__side">
            <label></label>
          </div>
          <div class="gamma-viewer__rate">
            <ic-price-spinner
              [(ngModel)]="rowData.value"
              [disabled]="!gammaLadderModel.edit"
              [externalState]="gammaLadderModel.externalState"
              [showValidationBar]="false"
              [productCode]="gammaLadderModel.currencyPair.product"
              [inverted]="gammaLadderModel.currencyPair.inverted"
              [dead]="!gammaLadderModel.edit"
              (ngModelChange)="handleMidSpinnerChange(rowData)"
              size="sm"
            >
            </ic-price-spinner>
          </div>
          <div class="gamma-viewer__delta">
            <label></label>
          </div>
          <div class="gamma-viewer__delete">
            <label></label>
          </div>
        </div>
      </div>
      <!-- Below mid legs-->
      @for (rowData of gammaLadderModel.gammaLegsBelow; track rowData.legId) {
      <div class="gamma-viewer__row" [ngClass]="{ 'disabled' : !gammaLadderModel.edit }">
        <div class="gamma-viewer__row__divider">
          <div class="gamma-viewer__side">
            <label>{{rowData.directionLabel}}</label>
          </div>
          <div class="gamma-viewer__amount gamma-viewer__cell">
            <bfx-amount-spinner
              [externalState]="0"
              [showValidationBar]="false"
              [(ngModel)]="rowData.amount"
              [keyupAssignZero]="false"
              [disabled]="!gammaLadderModel.edit"
              [dead]="!gammaLadderModel.edit"
              size="sm"
            >
            </bfx-amount-spinner>
          </div>
          <div class="gamma-viewer__rate gamma-viewer__cell gamma-viewer__cell--last">
            <ic-price-spinner
              [(ngModel)]="rowData.rate"
              [disabled]="!gammaLadderModel.edit"
              [externalState]="gammaLadderModel.externalState"
              [showValidationBar]="false"
              [productCode]="gammaLadderModel.currencyPair.product"
              [inverted]="gammaLadderModel.currencyPair.inverted"
              [dead]="!gammaLadderModel.edit"
              [deadNeg]="gammaLadderModel.hasError"
              [style.color]="rowData.borderColor"
              (ngModelChange)="handleSpinnerChange(rowData)"
              [max]="rowData.maxRate"
              [min]="rowData.minRate"
              size="sm"
            ></ic-price-spinner>
          </div>
          <div class="gamma-viewer__delta">
            <div>
              <label aria-multiline="false">{{rowData.deltaLabel}}</label>
            </div>
          </div>
          <div
            [ngClass]="{
              'gamma-viewer__delete__enabled': gammaLadderModel.edit,
              'gamma-viewer__delete__disabled': !gammaLadderModel.edit
            }"
            class="gamma-viewer__delete"
            [attr.disabled]="!gammaLadderModel.edit"
          >
            <bfx-icon-button
              class="remove-leg-button"
              tabindex="-1"
              size="sm"
              iconClass="icon_ion_remove_circle_filled"
              (action)="removeLeg(rowData)"
              title="Remove Leg"
              [disabled]="!gammaLadderModel.edit"
            ></bfx-icon-button>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>
